<template>
  <!-- Modal terms -->
  <div
    id="accepted-credit-card-modal"
    aria-hidden="true"
    aria-labelledby="acceptedCreditCardLabel"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="termsLabel" class="modal-title">{{ $t('Kredi Kartı Bilgilendirme') }}</h4>
          <button aria-hidden="true" class="close" data-dismiss="modal" type="button">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <div class="text-center mb-1">
            <img class="small-size" src="/img/odeme_mukellef.png" />
          </div>
          <p>
            {{ $t('Kredi Kartı Bilgilendirme Text') }}
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn_1" data-dismiss="modal" type="button">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'AcceptedCreditCardModal',
};
</script>
